<template>
    <div style="height:100vh; display:flex; flex-direction:column; padding:20px; box-sizing:border-box;">

        <div style="flex:1; display:flex; min-height:0;">

            <!-- LEFT -->
            <div style="width:400px; flex-shrink:0; border:1px solid #eee; overflow:auto;">
                <tab-tree-view :item="tabTree" :selected="selectedTab" :allowEdit="true" :all="flattedTabs"
                    @toggle-item="toggleItem" @modify-item="modifyItem" />
            </div>
            <!-- RIGHT -->
            <div style="flex:1; margin-left:10px; display:flex; flex-direction:column; min-height:0;">

                <!-- messages -->
                <div v-if="errorMessage" class="alert alert-danger">{{ errorMessage }}</div>
                <div v-if="successMessage" class="alert alert-success">{{ successMessage }}</div>

                <!-- editor + preview -->
                <div style="flex:1; display:flex; gap:10px; min-height:0;" v-show="selectedTab.Id">

                    <!-- EDITOR -->
                        
                    <div style="flex:1 1 50%; max-width:50%; display:flex; flex-direction:column; min-height:0; position:relative;">
                        <textarea id="md"></textarea>

                        <div v-show="showDocumentPicker" class="document-picker-panel shadow">
                            <div class="d-flex align-items-center justify-content-between mb-2">
                                <strong>Insert Document</strong>
                                <button type="button" class="btn btn-link btn-sm p-0" @click="showDocumentPicker = false">Close</button>
                            </div>

                            <select v-model="selectedPublicDocumentId" class="form-control form-control-sm mb-2">
                                <option disabled :value="null">Select a public document</option>
                                <option v-for="doc in publicDocuments" :key="doc.Id" :value="doc.Id">
                                    {{ publicDocumentLabel(doc) }}
                                </option>
                            </select>

                            <button class="btn btn-dark btn-sm btn-block" @click="insertPublicDocument">Insert</button>
                        </div>
                    </div>

                    <!-- PREVIEW -->
                        <div style="flex:1 1 50%; max-width:50%; display:flex; flex-direction:column; border:1px solid #eee; min-height:0;">

                        <div style="height:38px; border-bottom:1px solid #eee; background:#f8f9fa;"></div>

                        <!-- scroll content -->
                        <div class="preview-content" style="flex:1; padding:10px;">
                            <v-calendar v-if="isCalendar" is-expanded>
                                <template v-slot:day-content="slotProps">
                                    <div class="calendar-day">
                                        <div class="day-header">{{ slotProps.day.day }}</div>

                                        <div v-if="calendarData[slotProps.day.id]" class="event-list">
                                            <div v-for="(e, i) in calendarData[slotProps.day.id].slice(0, 2)" :key="i"
                                                class="event-pill">
                                                {{ e }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </v-calendar>

                            <div v-else v-html="renderPreview"></div>

                        </div>
                    </div>
                </div>

                <div v-show="selectedTab.Id" style="padding-top:10px;">
                    <button class="btn btn-dark btn-sm" @click="submit">Save</button>
                    <button class="btn btn-secondary btn-sm" @click="revert">Revert</button>
                </div>
                <div style="display:none">
                    <input type="file" ref="file" @change="handleFile">
                </div>


            </div>
        </div>
    </div>

</template>


<script>
/* eslint-disable */

import axios from 'axios'
import TabTreeView from '../../components/TabTreeView.vue'
import { GuidService } from '../../services/guid'

export default {
    components: { TabTreeView },

    data: function () {
        return {
            errorMessage: '',
            successMessage: '',
            pageContent: '',
            editorContent: '',
            mdeInstance: null,
            publicDocuments: [],
            showDocumentPicker: false,
            selectedPublicDocumentId: null,

            tabTree: { Name: 'Tabs', Id: null, Children: [] },
            flattedTabs: [],
            selectedTab: { Id: null }
        }
    },

    created: function () {
        this.fetchTabs()
    },

    mounted: function () {
        this.mdeInstance = new SimpleMDE({
            element: document.getElementById('md'),
            spellChecker: false,

            hideIcons: ["preview", "side-by-side", "fullscreen"],
            status: false,

            toolbar: [
                "bold", "italic", "heading", "|",
                "quote", "unordered-list", "ordered-list", "|",
                "guide",
                // FILE UPLOAD BUTTON
                {
                    name: "upload",
                    action: () => {
                        this.$refs.file.click();
                    },
                    className: "fa fa-upload",
                    title: "Upload file"
                },

                // FORM LINK BUTTON
                {
                    name: "form",
                    action: () => {
                        this.promptFormLink();
                    },
                    className: "fa fa-link",
                    title: "Insert FormAssembly Link"
                },

                // DOCUMENT PICKER BUTTON
                {
                    name: "document",
                    action: () => {
                        this.toggleDocumentPicker();
                    },
                    className: "fa fa-file-text-o",
                    title: "Insert document"
                }
            ]
        });


        var self = this

        this.editorContent = this.mdeInstance.value()

        this.fetchPublicDocuments()

        this.mdeInstance.codemirror.on("change", function () {
            self.editorContent = self.mdeInstance.value()
        })
    },

    computed: {

        isCalendar: function () {
            return /##\s+\d{4}-\d{2}-\d{2}/.test(this.editorContent || '')
        },

        renderPreview: function () {
            return marked(this.editorContent || '')
        },

        calendarData: function () {
            var lines = (this.editorContent || '').split('\n')
            var grouped = {}
            var currentDate = null

            lines.forEach(function (line) {
                var match = line.match(/^##\s+(\d{4}-\d{2}-\d{2})/)

                if (match) {
                    currentDate = match[1]
                    grouped[currentDate] = []
                } else if (currentDate && line.trim().indexOf('-') === 0) {
                    grouped[currentDate].push(line.replace('-', '').trim())
                }
            })

            return grouped
        },


        rootUrl: function () {
            if (window.location.origin === 'http://localhost:3000') {
                return 'http://localhost:62737';
            } else {
                return '.';
            }
        }

    },

    methods: {
        promptFormLink: function () {
            var link = prompt("Paste FormAssembly link");
            if (!link) return;

            if (link.indexOf('http') !== 0) {
                link = 'https://' + link;
            }

            this.insertAtCursor(
                '<iframe src="' + link + '" width="100%" height="100%"></iframe>'
            );
        },

        fetchPublicDocuments: function () {
            var self = this

            axios.get(this.rootUrl + '/api/hlsdocuments/public')
                .then(function (res) {
                    self.publicDocuments = res.data || []
                    if (!self.selectedPublicDocumentId && self.publicDocuments.length > 0) {
                        self.selectedPublicDocumentId = self.publicDocuments[0].Id
                    }
                })
                .catch(function () {
                    self.publicDocuments = []
                })
        },

        toggleDocumentPicker: function () {
            this.showDocumentPicker = !this.showDocumentPicker
            if (this.showDocumentPicker) {
                this.fetchPublicDocuments()

                if (!this.selectedPublicDocumentId && this.publicDocuments.length > 0) {
                    this.selectedPublicDocumentId = this.publicDocuments[0].Id
                }
            }
        },

        insertPublicDocument: function () {
            if (!this.selectedPublicDocumentId) return

            var doc = this.publicDocuments.find(function (item) {
                return item.Id === this.selectedPublicDocumentId
            }, this)

            if (!doc) return

            var title = this.publicDocumentLabel(doc) || 'Document'
                .replace(/\]/g, '\\]')
                .replace(/\(/g, '\\(')
                .replace(/\)/g, '\\)')

            var url = this.rootUrl + '/api/files/' + doc.Id
            this.insertAtCursor('[' + title + '](' + url + ')')
            this.showDocumentPicker = false
        },

        publicDocumentLabel: function (doc) {
            if (!doc) return ''

            return doc.Title || doc.FileName || 'Untitled document'
        },

        insertAtCursor: function (text) {
            var cm = this.mdeInstance.codemirror;
            var doc = cm.getDoc();

            var cursor = doc.getCursor();
            doc.replaceRange(text + '\n', cursor);
        },
        handleFile: function () {
            var file = this.$refs.file.files[0];
            if (!file) return;

            var guid = GuidService.new();
            var formData = new FormData();
            formData.append('file', file);

            var self = this;

            axios.put(
                self.rootUrl + '/api/files/add/' + guid,
                formData
            )
                .then(function () {

                    var url = self.rootUrl + '/api/files/' + guid;
                    var text = '';

                    if (file.type.indexOf('video') !== -1) {
                        text = '<video controls><source src="' + url + '" type="' + file.type + '"></video>';
                    }
                    else if (file.type.indexOf('image') !== -1) {
                        text = '![](' + url + ')';
                    }
                    else {
                        text = '[](' + url + ')';
                    }

                    self.insertAtCursor(text);

                })
                .catch(function () {
                    self.errorMessage = 'File upload failed';
                });
        },
        fetchTabs: function () {
            var self = this

            axios.get('/api/webtabs/tree').then(function (res) {
                self.tabTree.Children = res.data || []
            })

            axios.get('/api/webtabs/all').then(function (res) {
                self.flattedTabs = res.data || []
            })
        },

        toggleItem: function (tab) {
            this.selectedTab = tab
            this.loadPage(tab.Id)
        },

        loadPage: function (id) {
            var self = this
            this.errorMessage = ''

            axios.get('api/pagecontent/' + id)
                .then(function (res) {
                    if (res.data && res.data.Content) {
                        self.pageContent = res.data.Content
                    } else {
                        self.pageContent = ''
                    }

                    self.mdeInstance.value(self.pageContent)
                    self.editorContent = self.pageContent
                })
                .catch(function (e) {
                    console.log(e);
                    self.errorMessage = 'Failed to load content'
                })
        },

        submit: function () {
            var self = this

            axios.post('/api/pagecontent/' + this.selectedTab.Id, {
                PageContent: this.editorContent
            })
                .then(function () {
                    self.successMessage = 'Saved'
                })
                .catch(function () {
                    self.errorMessage = 'Save failed'
                })
        },

        revert: function () {
            if (!this.selectedTab.Id) return
            this.loadPage(this.selectedTab.Id)
            this.successMessage = 'Reverted'
        },

        modifyItem: function (itemAct) {
            if (itemAct.action === 'edit') {

                var model = itemAct.model;

                if (itemAct.model.Name === itemAct.tab.name) return;

                model.Name = itemAct.tab.name;
                model.Mode = itemAct.tab.mode;

                axios.post('api/webtabs/update/' + model.Id, model)
                    .then(() => {
                        this.fetchTabs();
                    });
            }

            else if (
                itemAct.action === 'insertabove' ||
                itemAct.action === 'insertbelow'
            ) {

                let curr = this.flattedTabs.find(f => f.Id === itemAct.model.Id);

                let siblings = this.flattedTabs
                    .filter(f => f.Parent === itemAct.model.Parent)
                    .sort((a, b) => a.Ordinal - b.Ordinal);

                let indexOfCurr = siblings.indexOf(curr);
                let currOrdinal = curr.Ordinal;

                let newOrdinal;

                if (itemAct.action === 'insertabove') {
                    if (indexOfCurr === 0) {
                        newOrdinal = currOrdinal - 1;
                    } else {
                        newOrdinal =
                            (currOrdinal + siblings[indexOfCurr - 1].Ordinal) / 2;
                    }
                }
                else {
                    if (indexOfCurr === siblings.length - 1) {
                        newOrdinal = currOrdinal + 1;
                    } else {
                        newOrdinal =
                            (currOrdinal + siblings[indexOfCurr + 1].Ordinal) / 2;
                    }
                }

                let tabToAdd = {
                    Id: GuidService.new(),
                    Name: itemAct.tab.name,
                    Parent: itemAct.model.Parent,
                    Ordinal: newOrdinal,
                    Mode: itemAct.tab.mode
                };

                axios.put('api/webtabs/add', tabToAdd)
                    .then(() => {
                        this.fetchTabs();
                    })
                    .catch(() => {
                        this.errorMessage = 'Failed to create tab';
                    });
            }

            else if (itemAct.action === 'addchild') {

                let newTab = {
                    Id: GuidService.new(),
                    Name: itemAct.tab.name,
                    Parent: itemAct.model.Id,
                    Ordinal: 1,
                    Mode: itemAct.tab.mode
                };

                axios.put('api/webtabs/add', newTab)
                    .then(() => {
                        this.fetchTabs();
                    });
            }

            else if (itemAct.action === 'delete') {

                if (
                    itemAct.model.Children &&
                    itemAct.model.Children.length > 0
                ) {
                    this.errorMessage =
                        'This tab cannot be deleted because it has one or more sub tabs.';
                    return;
                }

                axios.post(
                    'api/webtabs/delete/' + itemAct.model.Id
                ).then(() => {
                    this.fetchTabs();
                });
            }
        }
    }
}
</script>

<style>
.CodeMirror {
    height: 100% !important;
}

.CodeMirror-scroll {
    height: 100% !important;
    overflow: auto !important;
}

.preview-content {
    overflow-x: auto;
    overflow-y: auto; 
}

.preview-content img {
    max-width: none; 
}

.document-picker-panel {
    position: absolute;
    top: 46px;
    right: 12px;
    z-index: 20;
    width: 320px;
    max-height: 320px;
    overflow: auto;
    background: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
}
</style>
